import { Helmet } from 'react-helmet';

import { configApiRef, useApi } from '@backstage/core-plugin-api';

export type PageTitleProps = {
  title: string;
};

export const PageTitle = ({ title }: PageTitleProps) => {
  const configApi = useApi(configApiRef);
  const appTitle = configApi.getOptionalString('app.title') || 'Confidence';

  return <Helmet defaultTitle={`${title} | ${appTitle}`} />;
};
